$(document).ready(function(){
    
    // Image Zoom
    $('#item-image .zoom').zoom();
	//$('#ex2').zoom({ on:'grab' });
	//$('#ex3').zoom({ on:'click' });			 
    //$('#ex4').zoom({ on:'toggle' });
    
    // Thumbnails
    $('#item-image').simpleGal({
        galltime : 400,
        gallcontent: '.content',
        gallthumbnail: '.thumbnail',
        gallthumb: '.thumb'
    });

    $('.tabitem').click(function(){
        var ind = $(this).index();
        $('.tabitem').each(function(){
            if ($(this).index() == ind) {
                $(this).addClass("tab-active");
            } else {
                $(this).removeClass("tab-active");
            }
        });
        $('.tabContent').each(function(){
            if ($(this).index() == ind) {
                $(this).addClass("tab-active");
            } else {
                $(this).removeClass("tab-active");
            }
        });
    });
    
});